module.exports = __webpack_public_path__ + "img/IzzNina.d8a78b07.png";